module.exports = __webpack_public_path__ + "img/armenia.89fca99.webp";